import { makeStyles } from '@material-ui/core';
import { MDSImage } from '@marqvision/mds-v2';

const useStyles = makeStyles(({ color }) => ({
  video: {
    width: '100%',
    display: 'grid',
    backgroundColor: color.bg.surface.inverse.dark,
  },
}));

type Props = {
  url: string;
};

export const VideoImageContent = (props: Props) => {
  const { url } = props;
  const classes = useStyles();

  const isVideo = isVideoExtension(url);

  if (isVideo)
    return (
      <div className={classes.video}>
        <video controls src={url} width="100%" />
      </div>
    );
  return <MDSImage removeBorderRadius width="100%" height="349px" src={url} />;
};

const isVideoExtension = (url: string) => {
  const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'm4v', '3gp', 'ts'];
  return videoExtensions.some((ext) => new URL(url).pathname.endsWith(ext));
};
